import { Card, Checkbox, Typography } from '@navi/web-ui/lib/primitives';
import React from 'react';
import styles from './index.module.scss';
import { IOptionsList } from './interfaces';
import cx from 'classnames';
import { LoadingIcon } from '@navi/web-ui/lib/icons';

const OptionsList: React.FC<IOptionsList> = ({
  options,
  showLoader,
  isMultiSelect,
  optionTemplate,
  onOptionClick,
  isOptionSelected,
  notFoundCopy,
  customOptionsContainer
}) => {
  if (showLoader) {
    return (
      <Card className={styles.options}>
        <div className={styles.loader}>
          <LoadingIcon />
        </div>
      </Card>
    );
  }

  if (!options.length) {
    return (
      <Card className={styles.options}>
        <Typography variant="h4" className={styles.noResult}>
          {notFoundCopy ? notFoundCopy : 'No results found !'}
        </Typography>
      </Card>
    );
  }

  const disableClick = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <Card className={cx(styles.options, customOptionsContainer)}>
      {options.map(option => (
        <div key={option.value} onClick={() => onOptionClick(option)}>
          {isMultiSelect ? (
            <Checkbox
              title={option.label}
              customTemplate={
                optionTemplate &&
                typeof optionTemplate === 'function' &&
                (React.isValidElement(optionTemplate(option)) ||
                  typeof optionTemplate(option) === 'string')
                  ? optionTemplate(option)
                  : null
              }
              onClick={disableClick}
              checked={isOptionSelected(option)}
              checkboxOuterWrapperClass={cx(styles.option, {
                [styles.selected]: isOptionSelected(option)
              })}
              readOnly
            />
          ) : optionTemplate &&
            typeof optionTemplate === 'function' &&
            (React.isValidElement(optionTemplate(option)) ||
              typeof optionTemplate(option) === 'string') ? (
            optionTemplate(option)
          ) : (
            <div
              className={cx(styles.option, {
                [styles.selected]: isOptionSelected(option)
              })}
            >
              <Typography variant="p3" className={cx(styles['label--title'])}>
                {option.label}
              </Typography>
            </div>
          )}
        </div>
      ))}
    </Card>
  );
};

export default OptionsList;
